import { normalizeString } from '@change-corgi/config/fcm/normalizers';

import { createFcmConfig } from '../shared/factory';

export const FCM_MEMBERSHIP_PPMU_OFFSITE_LINK = createFcmConfig('membership_ppmu_offsite_link', {
	normalizer: normalizeString,
	defaultValue: undefined,
});
